import axios from 'axios'
import config from '../config'

const MemberPoint = {
    state: {
     memberPointN: {},   
     memberPointS: {},   
     error: false,
     msg: ''
    },
    mutations: {
        ERROR: (state, error) => state.error = error,
        MSG: (state, msg) => state.msg = msg,
        MemberPointN: (state, memberPointN) => state.memberPointN = memberPointN,
        MemberPointS: (state, memberPointS) => state.memberPointS = memberPointS
    },
    actions: {
       async updateMemberPoint({commit}, data){
            await axios({
                method:'post',
                url: config.UPDATE_MEMBER_POINT,
                data: data
            })
            .then((result) => {
                commit('ERROR', result.data.error)
                commit('MSG', result.datamsg)
            }).catch((err) => {
                console.log(err);
            });
        },
        async fetchMemberPointN({commit}, data){
            await axios({
                method:'post',
                url: config.LOAD_MEMBER_POINT_DETAIL,
                data: data
            })
            .then((result) => {
                commit('MemberPointN', result.data.results)
            }).catch((err) => {
                console.log(err);
            });
        },
        async fetchMemberPointS({commit}, data){
            await axios({
                method:'post',
                url: config.LOAD_MEMBER_POINT_DETAIL,
                data: data
            })
            .then((result) => {
                commit('MemberPointS', result.data.results)
            }).catch((err) => {
                console.log(err);
            });
        }
    },
    getters: {
        getMemberPointN: state => state.memberPointN,
        getMemberPointS: state => state.memberPointS,
        getMemberPointError: state => state.error,
        getMemberPointMsg: state => state.msg
    },
}

export default MemberPoint;